var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "member-points-mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.close.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "section",
        {
          staticClass: "member-points-popup",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": _vm.titleId,
          },
        },
        [
          _c(
            "button",
            {
              staticClass: "member-points-close",
              attrs: {
                type: "button",
                "aria-label": _vm.$t("member_popup.close"),
              },
              on: { click: _vm.close },
            },
            [
              _c("i", {
                staticClass: "fa fa-close",
                attrs: { "aria-hidden": "true" },
              }),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "member-points-badge",
              attrs: { "aria-hidden": "true" },
            },
            [
              _c("span", [_vm._v("VIP")]),
              _c("strong", [_vm._v(_vm._s(_vm.level))]),
            ]
          ),
          _c("h2", { attrs: { id: _vm.titleId } }, [
            _vm._v(_vm._s(_vm.$t("member_popup.title"))),
          ]),
          _c("p", { staticClass: "member-points-message" }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(
                  _vm.$t("member_popup.message", {
                    points: _vm.formatNumber(_vm.earnedPoints),
                    nextLevel: _vm.nextLevel,
                    remaining: _vm.formatNumber(_vm.remainingPoints),
                  })
                ) +
                "\n\t\t"
            ),
          ]),
          _c("div", { staticClass: "member-points-progress-card" }, [
            _c("div", { staticClass: "member-points-progress-head" }, [
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm.$t("member_popup.progress", {
                      current: _vm.formatNumber(_vm.currentPoints),
                      target: _vm.formatNumber(_vm.nextLevelPoints),
                    })
                  )
                ),
              ]),
              _c("span", [_vm._v("VIP" + _vm._s(_vm.level))]),
            ]),
            _c(
              "div",
              {
                staticClass: "member-points-progress",
                attrs: {
                  role: "progressbar",
                  "aria-valuenow": _vm.currentPoints,
                  "aria-valuemin": "0",
                  "aria-valuemax": _vm.nextLevelPoints,
                },
              },
              [_c("span", { style: { width: _vm.progressPercent + "%" } })]
            ),
            _c("p", [
              _vm._v(
                _vm._s(
                  _vm.$t("member_popup.next", {
                    nextLevel: _vm.nextLevel,
                    remaining: _vm.formatNumber(_vm.remainingPoints),
                  })
                )
              ),
            ]),
          ]),
          _c("label", { staticClass: "member-points-suppress" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.suppressForSevenDays,
                  expression: "suppressForSevenDays",
                },
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.suppressForSevenDays)
                  ? _vm._i(_vm.suppressForSevenDays, null) > -1
                  : _vm.suppressForSevenDays,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.suppressForSevenDays,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.suppressForSevenDays = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.suppressForSevenDays = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.suppressForSevenDays = $$c
                  }
                },
              },
            }),
            _c("span", [_vm._v(_vm._s(_vm.$t("member_popup.suppress")))]),
          ]),
          _c("div", { staticClass: "member-points-actions" }, [
            _c(
              "button",
              {
                staticClass: "member-points-later",
                attrs: { type: "button" },
                on: { click: _vm.close },
              },
              [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.$t("member_popup.later")) +
                    "\n\t\t\t"
                ),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "member-points-rewards",
                attrs: { type: "button" },
                on: { click: _vm.close },
              },
              [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.$t("member_popup.rewards")) +
                    "\n\t\t\t"
                ),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }